<div class="cmx-navbar__legal-entity-filtering" *ngIf="version !== 3">
  <label class="cmx-navbar__legal-entity-filtering-icon cmx-icon-magnifier-glass"></label>
  <input
    class="cmx-navbar__legal-entity-filtering-input"
    (input)="onSearchTermChange($event)"
    [ngClass]="{ 'cmx-navbar__legal-entity-filtering-input--rtl': isRtl }"
    type="text"
    pattern="[^A-Za-z0-9]+"
    [placeholder]="legalEntity.searchPlaceholder | async"
  />
</div>
<div
  *ngIf="((legalEntity.isLoading | async) || (legalEntity.message | async)) && version !== 3"
  class="cmx-navbar__legal-entity-message"
>
  <div *ngIf="!(legalEntity.isLoading | async)" class="cmx-navbar__legal-entity-message-text">
    {{ legalEntity.message | async }}
  </div>
  <cmx-inline-loader *ngIf="legalEntity.isLoading | async"></cmx-inline-loader>
</div>
<div appScroll [scrollCallback]="scrollCallback" class="cmx-navbar__legal-entity-items scrollbar" *ngIf="version !== 3">
  <div
    class="cmx-navbar__legal-entity-item"
    [ngClass]="{
      'cmx-navbar__legal-entity-item--active':
        entity.legalEntityId === (legalEntity.legalEntityActive | async)?.legalEntityId
    }"
    (click)="legalEntity.legalEntityChange.emit(entity.legalEntityId)"
    *ngFor="let entity of legalEntity.legalEntitiesList | async"
    [id]="entity.legalEntityId"
  >
    <div class="cmx-navbar__legal-entity-name">{{ entity.legalEntityDesc }}</div>
    <div
      class="cmx-navbar__legal-entity-id"
      [innerHtml]="'#' + entity.legalEntityTypeCode | highlight: searchTerm"
    ></div>
  </div>
</div>
<cwc-entity-selector
  *ngIf="version === 3"
  id="entitySelector"
  slot="legal-entity-selection"
  (cwcEntityChanged)="setLegalEntityByComponent($event)"
  [collapsed]="isCollapsed"
  (cwcModalOpened)="onModalShow($event)"
  [variant]="layout.variantHeader | async"
  [modalLabelApply]="layout.modalLabelApply | async"
  [modalLabelCancel]="layout.modalLabelCancel | async"
  [modalLabelChoose]="layout.modalLabelChoose | async"
  [modalLabelEmptyHeader]="layout.modalLabelEmptyHeader | async"
  [modalLabelEmptyMessage]="layout.modalLabelEmptyMessage | async"
  [modalLabelFilter]="employeeVariant ? (legalEntity.searchPlaceholder | async) : (layout.modalLabelFilter | async)"
  [modalTitle]="layout.modalTitle | async"
  [class]="!modalOpened ? '' : 'noCollapsable'"
  [ngClass]="{
    displayFlex: isCollapsed,
    noPointerEvents: !!!(legalEntity.legalEntitiesList | async).length && !employeeVariant
  }"
  (cwcInputChange)="onSearchChange($event)"
  [disableFilter]="employeeVariant"
  [entityName]="entityName"
  [entityId]="entityId"
>
  <ng-container
    *ngIf="
      !(legalEntity.isLoading | async) &&
        !!!(legalEntity.legalEntitiesList | async)?.length &&
        employeeVariant &&
        version === 3;
      else entityList
    "
  >
    <cwc-empty-result
      *ngIf="!(legalEntity.isLoading | async) && !!!(legalEntity.legalEntitiesList | async)?.length"
      [icon]="
        !!!(legalEntity.legalEntitiesList | async)?.length && searchInput?.length >= minCharachterInput
          ? 'information-rounded-fill'
          : 'search'
      "
      class="empty-message fade-in"
      variant="flat"
      [header]="
        !!!(legalEntity.legalEntitiesList | async)?.length && searchInput?.length >= minCharachterInput
          ? (layout.modalLabelEmptyHeader | async)
          : null
      "
    >
      {{ legalEntity.message | async }}
    </cwc-empty-result>
  </ng-container>
  <div *ngIf="(legalEntity.isLoading | async) && employeeVariant" class="loader-content">
    <cwc-loader class="fade-in loader"></cwc-loader>
  </div>
  <ng-template #entityList>
    <ng-container>
      <cwc-entity-selector-item
        *ngFor="let entity of legalEntity.legalEntitiesList | async"
        class="fade-in"
        [id]="entity.legalEntityId"
        attr.entity-name="{{ entity.legalEntityDesc }}"
        attr.entity-id="{{ entity.legalEntityTypeCode }}"
        [active]="
          employeeVariant ? null : entity.legalEntityId === (legalEntity.legalEntityActive | async)?.legalEntityId
        "
      ></cwc-entity-selector-item>
    </ng-container>
  </ng-template>
</cwc-entity-selector>
